export const Services = {
  DASHBOARD: {
    path: process.env.REACT_APP_DASHBOARD,
    method: "",
    descrp: "API DASHBOARD",
  },
  ADMIN: {
    path: process.env.REACT_APP_ADMIN,
    method: "",
    descrp: "API TO HANDLE ADMIN",
  },
  AUDIT: {
    path: process.env.REACT_APP_AUDIT,
    method: "",
    descrp: "API TO HANDLE AUDIT",
  },
  TRACEABILITY: {
    path: process.env.REACT_APP_TRACEABILITY,
    method: "",
    descrp: "API TO HANDLE TRACEABILITY",
  },
  finance: {
    path: process.env.REACT_APP_FINANCE,
    method: "",
    descrp: "API Finance",
  },
  REPORT: {
    path: process.env.REACT_APP_REPORT,
    method: "",
    descrp: "API Report",
  },
  MAIL: {
    path: process.env.REACT_APP_MAIL,
    method: "",
    descrp: "API Mail",
  },
  REPORTS: {
    path: process.env.REACT_APP_REPORTS,
    method: "",
    descrp: "API Report",
  },
  OBLURL: {
    path: process.env.REACT_APP_OBL,
    method: "",
    descrp: "URL OBL project",
  },
  DOCUMENTS: {
    path: process.env.REACT_APP_DOCUMENTS,
    method: "",
    descrp: "API Documents",
  },
  TICKETS: {
    path: process.env.REACT_APP_TICKETS,
    method: "",
    descrp: "API Tickets",
  },
  REPORT_SERVICE: {
    path: process.env.REACT_APP_BUILD_REPORT_SD,
    descrp: "API Reportes",
  },
  WAREHOUSE: {
    path: process.env.REACT_APP_WAREHOUSE,
    method: "",
    descrp: "API TO HANDLE WAREHOUSE",
  },
};
